import { PermissionActions } from './actions'
import { PermissionGetters } from './getters'
import { PermissionMutations } from './mutations'
import { PermissionState } from './state'

export const PERMISSIONS_NAMESPACE = 'permissions'

export const Permission = {
  namespaced: true,
  state: PermissionState,
  actions: PermissionActions,
  mutations: PermissionMutations,
  getters: PermissionGetters,
}
